import { useContext } from 'react'
import Navbar from "../components/Navbar";
import { ThemeContext } from '../Contexts/themeProvider';
import Contact from '../views/Contact';
import ChatBot from '../LiveAi/ChatBot';
import ChatButton from '../LiveAi/ChatButton';
import AutoScrollImageList from '../components/AutoScrollImageList';

const Galary = ({chatOpen,setChatOpen,images}) => {
    const theme = useContext(ThemeContext);
    const darkMode = theme.state.darkMode;

  return (
    <div>
      <Navbar theme={theme} darkMode={darkMode}/>
      <AutoScrollImageList images={images}/>
      <Contact darkMode={darkMode}/>
      {/* Chat Button */}
      <ChatButton chatOpen={chatOpen} setChatOpen={setChatOpen}/>
      {chatOpen && <ChatBot darkMode={darkMode} chatOpen={chatOpen} setChatOpen={setChatOpen}/>}
    </div>
  )
}

export default Galary
